import React, {Component} from "react";
import SimpleModal from "../../../../../modules/popup/SimpleModal";
import ModalContainer from "../../../../../modules/commons/ModalContainer";
import SimpleInput from "../../../../../modules/SimpleInput";
import SimpleDDL from "../../../../../modules/SimpleDDL";
import FlexView from "react-flexview";
import SimpleButton from "../../../../../modules/commons/SimpleButton";

class MasterKSUFilter extends Component {
    handleSubmit = () => {
        this.props.onSubmit();
    };

    render() {
        return (
            <SimpleModal
                title="Filter"
                visible={this.props.visible}
                onClickClose={() => this.props.onClickClose()}
                content={
                    <ModalContainer>
                            <SimpleInput
                                id="input_text_kode_ksu"
                                name="kodeKSU"
                                label="Kode KSU"
                                value={this.props.selectedData.kodeKSU}
                                onChange={({target}) =>
                                    this.props.onValueChange(target.name, target.value)
                                }
                            />
                            <SimpleInput
                                id="input_text_nama_ksu"
                                name="name"
                                label="Nama KSU"
                                value={this.props.selectedData.name}
                                onChange={({target}) =>
                                    this.props.onValueChange(target.name, target.value)
                                }
                            />
                            <SimpleDDL
                                id="select_options_filter_kategori"
                                box="search"
                                name="category"
                                label="Kategori"
                                isClearable
                                options={this.props.dataKategoriDDL}
                                value={this.props.selectedData.category}
                                onChange={(value, {name}) => this.props.onValueChange(name, value)}
                            />
                            <SimpleDDL
                                id="select_options_filter_satuan"
                                box="search"
                                name="satuan"
                                label="Satuan"
                                isClearable
                                options={this.props.dataSatuanDDL}
                                value={this.props.selectedData.satuan}
                                onChange={(value, {name}) => this.props.onValueChange(name, value)}
                            />
                            <FlexView hAlignContent="right">
                                <SimpleButton type="button" secondary onClick={() => this.props.onClearForm()}>
                                    Hapus
                                </SimpleButton>
                                <SimpleButton onClick={this.handleSubmit}>Terapkan</SimpleButton>
                            </FlexView>
                    </ModalContainer>
                }
            />
        );
    }
}

export default MasterKSUFilter;